import React from 'react';

// Componenets
import File from '../file/file.jsx';
import Loader from '../loader.jsx';

class Folder extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: props.open
        };

        this.toggleOpen = this.toggleOpen.bind(this);
    }

    toggleOpen() {
        this.setState({
            open: !this.state.open
        });
    }

    render() {
        let filesJSX;
        if (this.props.folder.files) {
            filesJSX = this.props.folder.files.map(file => <File key={file.id} file={file} />);
        } else if (this.props.folder.fileError) {
            filesJSX = (
                <li className="error">
                    <img className="error-icon" src="/Content/img/icons/exclamation-triangle.svg" alt=""/>
                    {this.props.folder.fileError}
                </li>
            );
        }

        let folderContents = (
            <Loader loaded={!!this.props.folder.files || !!this.props.folder.fileError}>
                {this.props.folder.children.map(childFolder => <Folder key={childFolder.id} folder={childFolder} open={false}/>)}
                {filesJSX}
                {this.props.folder.children.length === 0 && this.props.folder.files && this.props.folder.files.length === 0 ? 
                    <li className="empty-folder">This folder is empty.</li> 
                    : null
                }
            </Loader>
        );

        return (
            this.props.silent ?     // silent mode makes it appear as if the contents of this folder are actually part of the parent folder
            folderContents :
            <li className="folder">
                <span className="folder-title" onClick={this.toggleOpen}>
                    <img className="folder-icon" src="/Content/img/icons/folder.svg" alt=""/>
                    {this.props.folder.text}
                </span>
                {this.state.open ?
                    <ul className="folder-children">
                        {folderContents}
                    </ul>
                    : null
                }
            </li>
        );
    }
}

export default Folder;